import React from "react";
import { useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import { GetAccessToken } from "../index";
import { useState } from 'react';
import Placeholder from 'react-bootstrap/Placeholder';
import "./Home.css";
import Button from 'react-bootstrap/Button';
import { EditResidentialReturn } from "./EditResidentialReturn";
import { EditRuralReturn } from "./EditRuralReturn";
import Modal from 'react-bootstrap/Modal';
import DataTable from 'react-data-table-component';
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
//import { APIProvider, Map, MapCameraChangedEvent } from "@vis.gl/react-google-maps";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { DateRangePicker } from 'rsuite';
import { CheckTreePicker, Stack } from 'rsuite';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import addMonths from 'date-fns/addMonths';
import 'rsuite/DateRangePicker/styles/index.css';
import 'rsuite/CheckTreePicker/styles/index.css';
import "./GetReturnsListResidentialandRural.css";
import { useTheme } from './ThemeContext';
import { Box, CircularProgress } from '@mui/material';
import { msalConfig } from '../authConfig';
import { useAppConfig } from '../config/AppConfigContext';
import { useNavigate } from 'react-router-dom'
const predefinedDateRanges = [
    {
        label: 'Last Month',
        value: [startOfMonth(addMonths(new Date(), -1)), new Date()]
    },
    //{
    //    label: 'Last Month',
    //    value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))]
    //},
    {
        label: 'Last 3 Months',
        value: [startOfMonth(addMonths(new Date(), -2)), new Date()]
    }
    ,
    {
        label: 'Last 6 Months',
        value: [startOfMonth(addMonths(new Date(), -5)), new Date()]
    }
    ,
    {
        label: 'Last 12 Months',
        value: [startOfMonth(addMonths(new Date(), -11)), new Date()]
    }
];

const returnStatusData = [
    {
        label: 'Duplicate',
        value: 'Duplicate'
    },
    {
        label: 'Processed',
        value: 'Processed'
    },
    {
        label: 'Unresolved',
        value: 'Unresolved'
    },
    {
        label: 'Error',
        value: 'Error'
    }
];

const returnSaleMethodData = [
    {
        label: 'P - Private Treaty(Neg.)',
        value: 'P - Private Treaty(Neg.)'
    },
    {
        label: 'A - Auction',
        value: 'A - Auction'
    },
    {
        label: 'T - Tender',
        value: 'T - Tender'
    }
];

const categoryTypes = [
    {
        label: 'Residential',
        value: 'ResidentialAll',
        children: [
            {
                label: 'Residence',
                value: 'Re-Residence'
            },
            {
                label: 'Residential Section',
                value: 'Re-Residential_Section'
            },
            {
                label: 'Unit',
                value: 'Re-Unit'
            },
            {
                label: 'Apartment',
                value: 'Re-Apartment'
            },
            {
                label: 'Home and Income',
                value: 'Re-Home_and_Income'
            },
            {
                label: 'Residential Investment Block',
                value: 'Re-Residential_Investment_Block'
            },
            {
                label: 'Residential - Other',
                value: 'Re-Unknown'
            },
            {
                label: 'Lifestyle Blocks',
                value: 'Re-Lifestyle_Blocks'
            }
        ]
    },
    {
        label: 'Rural',
        value: 'RuralAll',
        children: [
            {
                label: 'Lifestyle Blocks',
                value: 'Ru-Lifesty_leBlocks'
            },
            {
                label: 'Rural - Other',
                value: 'Ru-Unknown'
            },
            {
                label: 'Apartment',
                value: 'Ru-Apartment'
            },
            {
                label: 'Horticulture',
                value: 'Ru-Horticulture'
            },
            {
                label: 'Dairy',
                value: 'Ru-Dairy'
            },
            {
                label: 'Dairy Support',
                value: 'Ru-Dairy_Support'
            },
            {
                label: 'Arable',
                value: 'Ru-Arable'
            },
            {
                label: 'Forestry',
                value: 'Ru-Forestry'
            },
            {
                label: 'Livestock',
                value: 'Ru-Livestock'
            },
            {
                label: 'Livestock - Finishing',
                value: 'Ru-Livestock_-_Finishing'
            },
            {
                label: 'Livestock - Grazing',
                value: 'Ru-Livestock_-_Grazing'
            },
            {
                label: 'Livestock - Breeding',
                value: 'Ru-Livestock_-_Breeding'
            },
            {
                label: 'Livestock - High Country',
                value: 'Ru-Livestock_-_High_Country'
            },
            {
                label: 'Livestock_-_Special',
                value: 'Ru-Livestock_-_Special'
            }
            
        ]
    }
];

export function GetReturnsListResidentialandRural() {
    const { instance } = useMsal();
    const [List, setList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => setShowModal(false);
    const [globalFilterText, setGlobalFilterText] = useState("");
    const [showResidentialEdit, setshowResidentialEdit] = useState(false);
    const [showRuralEdit, setshowRuralEdit] = useState(false);
    const [saleId, setSaleId] = useState(0);
    const [data, setData] = useState(false);
    const [tableLoadStatus, setTableLoadStatus] = useState(false);
    const today = new Date();
    const [SelectedDateRange, setDateRangeValue] = useState([startOfMonth(addMonths(new Date(), -12)), startOfMonth(today)]);
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const [SelectedCategory, setReturnListCategory] = useState([]);
    const defaultReturnStatus = returnStatusData.map(item => item.value);
    /*const [SelectedReturnStatus, setReturnListStatus] = useState(["Duplicate", "Processed", "Unresolved"]);*/
    const [SelectedReturnStatus, setReturnListStatus] = useState([]);
    const [SelectedReturnSaleMethod, setReturnListSaleMethod] = useState([]);
    const [showChild, setShowChild] = useState(true);
    const [isValidCoordinates, setisValidCoordinates] = useState(false);
    const [expandedRows, setExpandedRows] = useState({});
    const { theme } = useTheme();
    const config = useAppConfig();
    const navigate = useNavigate();

    const columns = [
        {
            name: "Status",
            selector: row => row.status,
            width: '5rem',
            cell: (row) => {
                let iconClass = '';
                let color = '';
                let message = '';

                // Determine the icon class and color based on status
                if (row.status === 'Processed') {
                    iconClass = 'fas fa-check-circle'; // FontAwesome check icon
                    color = 'green';
                    message = 'This return has created a sale.'// Green color for processed
                }
                if (row.status === 'Unresolved') {
                    iconClass = 'fas fa-check-circle'; // FontAwesome check icon
                    color = 'green';
                    message = 'This return has created a sale.'// Green color for processed
                }
                if (row.status === 'Duplicate') {
                    iconClass = 'fas fa-clone'; // FontAwesome check icon
                    color = 'red';
                    message = 'This return has created a duplicate sale.'
                }
                    //case 'In Progress':
                    //    iconClass = 'fas fa-spinner fa-spin'; // FontAwesome spinner icon (with spinning effect)
                    //    color = 'blue';  // Blue for in-progress
                    //    break;
                   /* default:*/
                        //iconClass = 'fas fa-times'; // FontAwesome times icon for default
                        //color = 'gray';  // Default color
                        //break;
                

                // Return the icon with the color applied as inline style
                return (
                    <OverlayTrigger
                        placement="top" overlay={<Tooltip className="tooltipColor">
                            {message}
                        </Tooltip>}><i className={iconClass} style={{ color: color }}></i></OverlayTrigger>
                );
            }
        },
        {
            name: "Errors",
            selector: row => row.iserror,
            selector: row => row.errorMessages,
            width: '5rem',
            cell: (row) => {
                let iconClass = '';
                let color = '';
                let errorMessage = row.errorMessages;
                if (row.iserror) {
                    iconClass = 'fas fa-exclamation-triangle';  // Error icon
                        color = 'orange';  // Red color for error
                }
                // Return the icon with the color applied as inline style
                return (
                    <OverlayTrigger
                        placement="top" overlay={<Tooltip className="tooltipColor">
                            {errorMessage}
                        </Tooltip>}><i className={iconClass} style={{ color: color }}></i></OverlayTrigger>
                );
            }
        },
        //{
        //    field: 'expand', headerName: '', width: 50, renderCell: (params) => {
        //        const { row } = params;
        //        return (
        //            <IconButton onClick={() => handleExpand(row)}>
        //                {expandedRows[row.saleId] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        //            </IconButton>
        //        );
        //    },
        //},
        {
            //field: 'datamineSaleId', headerName: 'ReturnID' 
            name: "ReturnID",
            selector: row => row.datamineSaleId,
            sortable: true,
            width: '7rem',
        },
        {
            //field: 'streetNumber', headerName: 'Number' 
            name: "Number",
            selector: row => row.streetNumber,
            sortable: true,
            width: '7rem',
        },
        {
            //field: 'street', headerName: 'Street' 
            name: "Street",
            selector: row => row.street,
            sortable: true,
            //width: '7rem',
            grow: 2 // allows flexible growth
        },
        {
            //field: 'suburb', headerName: 'Suburb'
            name: "Suburb",
            selector: row => row.suburb,
            sortable: true,
            width: '7rem',
        },
        {
            //field: 'townCity', headerName: 'City'
            name: "City",
            selector: row => row.townCity,
            sortable: true,
            //width: '7rem',
            grow: 2 // allows flexible growth
        },
        {
            //field: 'organisationName', headerName: 'Organisation'
            name: "Organisation",
            selector: row => row.organisationName,
            sortable: true,
            //width: '9rem',
            grow: 3 // allows flexible growth

        },
        {
            //field: 'saleType', headerName: 'Property Type'
            name: "Property Type",
            selector: row => row.saleType,
            sortable: true,
            width:'9rem'
        },
        {
            //field: 'saleCategory', headerName: 'Property Category'
            name: "Property Category",
            selector: row => row.saleCategory,
            sortable: true,
            width: '11rem',
        },
        {
            //field: 'saleMethod', headerName: 'Method of Sale'
            name: "Method of Sale",
            selector: row => row.saleMethod,
            sortable: true,
            width: '11rem',
        },
        {
            //field: 'listPrice', headerName: 'List Price'
            name: "List Price",
            selector: row => row.listPrice,
            sortable: true,
            width: '8rem',
        },
        {
            //field: 'salePrice', headerName: 'Sale Price'
            name: "Sale Price",
            selector: row => row.salePrice,
            sortable: true,
            width: '8rem',
        },
        {
            //field: 'milkSolids', headerName: 'Milk Solids'
            name: "Milk Solids",
            selector: row => row.milkSolids,
            sortable: true,
            width: '8rem',
        },
        {
            //field: 'landArea', headerName: 'Land Area'
            name: "Land Area",
            selector: row => row.landArea,
            sortable: true,
            width: '8rem',
        },
        //{
        //    name: "Sale Price/Ha",
        //    /*selector: row => row.salePrice,*/
        //    sortable: true,
        //    width: '150px',
        //},
        {
            //field: 'settlementDate', headerName: 'Settlement Date'
            name: "Settlement Date",
            selector: row => row.settlementDate,
            sortable: true,
            width: '13rem',
        },
        {
            //field: 'unconditionalDate', headerName: 'Unconditional Date',
            //renderCell: (params) => {
            //    return params.value ? params.value.slice(0, 10) : '';
            //} 
            name: "Unconditional Date",
            selector: row => row.unconditionalDate.slice(0, 10),
            sortable: true,
            width: '13rem',
        },
        {
            //field: 'created', headerName: 'Load Date',
            //renderCell: (params) => {
            //    return params.value ? params.value.slice(0, 10) : '';
            //} 
            name: "Load Date",
            selector: row => row.created.slice(0, 10),
            sortable: true,
            width: '8rem',
        }
    ];


    const fetchReturnsList = async () => {

        //await sleep(2000); // Wait for 1 second

        const url = "api/ReturnList/GetReturnLists";
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        const accessToken = await GetAccessToken(tokenRequest);

        try {
            setTableLoadStatus(true);

            await fetch(url,
                {
                    method: "POST",
                    headers: new Headers(
                        {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${accessToken}`
                        }),
                    body: JSON.stringify({ fromDate: fromDate, toDate: toDate, SelectedCategory: SelectedCategory, SelectedReturnStatus: SelectedReturnStatus, SelectedReturnSaleMethod: SelectedReturnSaleMethod })
                })
                .then((response) => {
                    //console.log(response, 'response');
                    if (response.status !== 200 && response.status !== 201) {
                        console.log("not ok" + response.status);
                    }
                    else {
                        return response.json()
                    }
                })
                .then(data => {
                    //console.log(data)
                    if (data !== null && data !== undefined) {
                        setList(data);
                        setTableLoadStatus(false);
                    }
                    //console.log(List)
                    /*setTableLoadStatus(false);*/
                })
                //setIsLoading(false)
                .catch(error => {
                    console.error('Error:', error);
                    setTableLoadStatus(false);
                });
        }
        catch (error) {
            if (error.response) {
                setTableLoadStatus(false);
                console.log(error);
            }
        }
    }

    useEffect(() => {
        // the empty array in the param means we only run it once
        fetchReturnsList();
    }, []);

    //Submit delete request
    const sale = {
        saleId: saleId
    };
    const Submit = async (e) => {
        /*e.preventDefault();*/
        setShowModal(false);
        //alert("Hello1");

        const url = "api/DeleteReturn/DeleteReturn/?id=" + saleId;
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        try {
            const accessToken = await GetAccessToken(tokenRequest);
            //fetch
            fetch(url,
                {
                    method: 'DELETE',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify(sale),
                })
                .then((response) => {
                    //console.log(response, 'response');
                    if (response.status !== 200 && response.status !== 201) {
                        //console.log("not ok" + response.status);
                    }
                    else {
                        return response.json()
                    }
                }).then(data => {
                    setData(data)
                    //console.log(data)
                })
                .catch((err) => {
                    console.log(err);
                });
        }
        catch (error) {
            if (error.response) {
                console.log(error);
            }
        }
    }

    const handleGlobalFilter = (e) => {
        const value = e.target.value;
        setGlobalFilterText(value);
        fetchReturnsList();
    };

    const handleDateRangeChange = (e) => {
        setDateRangeValue(e);
        setFromDate(startOfMonth(e[0]));
        setToDate(endOfMonth(e[1]));
    };

    const handleDateRangeClose = () => {
        fetchReturnsList();
    };

    const handleReturnCategoryChange = (e) => {
        setReturnListCategory(e);
    };
    const handleReturnCategoryClose = (e) => {
        fetchReturnsList();
    };

    const handleReturnSaleMethodChange = (e) => {
        setReturnListSaleMethod(e);
    };
    const handleReturnStatusData = (e) => {
        setReturnListStatus(e);
    };
    const handleReturnSaleMethodClose = (e) => {
        fetchReturnsList();
    };
    const handleReturnStatusDataClose = (e) => {
        fetchReturnsList();
    };
    const handleDeleteSaleAlert = () => {
        alert("Sale deleted successfully");
        fetchReturnsList();
        setData(false);
    };

    //const searchReturn = () => {
    //    fetchReturnsList();
    //}


    const filteredData = List.filter((row) => {
        //return Object.values(row).some((value) =>
        //    (value||"").toString().toLowerCase().includes(globalFilterText.toLowerCase()));
        // Convert value to string, trim spaces, and normalize to lowercase
        return Object.values(row).some((value) => {
            // Convert value to string, trim spaces, and normalize to lowercase
            const stringValue = (value || "")
                .toString()
                .toLowerCase()
                .replace(/\s+/g, ' '); // Normalize spaces (replace multiple spaces with one)

            return stringValue.includes(globalFilterText.toLowerCase());
        });
    });    

    
    const ExpandedComponent = ({ data }) => {
        console.log(data);

        const center = {
            lat: Number(data.latitude),//51.509865,
            lng: Number(data.longitude),//-0.118092,
        };

        //if ((center.lat !== 0 && center.lat !== null) && (center.lng !== 0 && center.lng!==null)) {
        //    setisValidCoordinates(true);
        //    console.log(isValidCoordinates);
        //    setTimeout(() => {
        //    setisValidCoordinates(false);
        //    }, 5000);
        //}
        
        
        
        return data &&
            <>
            <div id="content">
                <div id="left">
                    <div style={{ fontSize: "large" }}><b><i>{data.fullAddress}</i></b></div>
                    <div>Return ID: {data.datamineSaleId}</div><br />
                    <div>Admin Notes:{data.adminNotes}</div>
                    <div><b>Bedrooms:</b>{data.bedrooms}</div>
                    <div><b>Bathrooms:</b>{data.bathrooms}</div>
                    <div>CV: ${data.valuation}</div>
                    <div>{data.errorMessages}</div>
                    <div><b>Flags:</b></div>
                    <div dangerouslySetInnerHTML={{ __html: data.flags }}></div>
                </div>
                <div id="middle">
                    {data.saleType === "Residential" || data.saleType === "residential" ?
                        <div><Button id="EditAndDelete" size="sm" onClick={() => {
                            setSaleId(data.saleId); setshowResidentialEdit(true); setshowRuralEdit(false); setShowChild(true)
                        }}><i className="bi bi-pencil-square"></i>&nbsp;Edit</Button></div> :
                        <div><Button id="EditAndDelete" size="sm" onClick={() => {
                            setSaleId(data.saleId); setshowResidentialEdit(false); setshowRuralEdit(true); setShowChild(true)
                        }}><i className="bi bi-pencil-square"></i>&nbsp;Edit</Button></div>
                    }&nbsp;
                    <div><Button id="EditAndDelete" size="sm" onClick={() => {
                        setSaleId(data.saleId);
                        setShowModal(true)
                    }}><i className="bi bi-trash3-fill"></i>&nbsp;Delete</Button></div>


                    {/*{data.saleType === "Residential" || data.saleType==="residential" ?*/}
                    {/*    <Button id= "EditAndDelete" size="sm" onClick={() => {*/}
                    {/*        setSaleId(data.saleId); setshowResidentialEdit(true); setshowRuralEdit(false);setShowChild(true)*/}
                    {/*    }}><i className="bi bi-pencil-square"></i>&nbsp;Edit</Button> :*/}
                    {/*    <Button id="EditAndDelete" size="sm" onClick={() => {*/}
                    {/*        setSaleId(data.saleId); setshowResidentialEdit(false); setshowRuralEdit(true);setShowChild(true)*/}
                    {/*    }}><i className="bi bi-pencil-square"></i>&nbsp;Edit</Button>*/}
                    {/*    }&nbsp;*/}
                    {/*    <Button id="EditAndDelete" size="sm" onClick={() => {*/}
                    {/*    setSaleId(data.saleId); setShowModal(true)*/}
                    {/*    }}><i className="bi bi-trash3-fill"></i>&nbsp;Delete</Button>*/}
                </div>
                <div id="right">  
                    {((center.lat !== 0 && center.lat !== null) && (center.lng !== 0 && center.lng !== null)) ? (
                        <APIProvider apiKey={config.googleMapsApiKey} onLoad={() => console.log(data.latitude, data.longitude)}>
                            <Map
                                style={{ width: '75vw', height: '25vh' }}
                                defaultCenter={center}
                                defaultZoom={13}
                                gestureHandling={'greedy'}
                                disableDefaultUI={true}>
                                <Marker position={center} />
                            </Map>
                        </APIProvider>
                    ) : (
                        <div><h4 style={{ paddingTop:"20px" }}>Map not available</h4></div>
                    ) }
            </div>
            <hr/>
            </div>
            
            </>
    };

    const handleGoBack = () => {
        setShowChild(false); // Hide child component
        fetchReturnsList();
    };

   const filtersanddatatable = () => {
        return (
            <>
                {/*<div className="container">*/}
                    <div>
                    <input className="spacing style" style={{ width: '25rem', marginRight: '1rem', marginLeft: '1rem' }}
                            type="search"
                            id="search"
                            placeholder="Search"
                            value={globalFilterText}
                            onChange={handleGlobalFilter}  
                        />
                    </div>
                    <div style={{display:'flex'}}>
                        <DateRangePicker className="spacing" style={{ width: '25rem', marginRight: '1rem', marginLeft:'1rem' }}
                            placeholder="Select Date Range"
                            format='MMM yyyy'
                            character=' - '
                            ranges={predefinedDateRanges}
                            value={SelectedDateRange}
                            onChange={handleDateRangeChange}
                            onExited={handleDateRangeClose}
                            cleanable={false}
                        />
                        <Stack spacing={10} direction="column" alignItems="flex-start">

                            <CheckTreePicker className="spacing" style={{ width: '25rem', marginRight: '1rem' }}
                                searchable={false}
                                defaultExpandAll
                                data={categoryTypes}
                                onChange={handleReturnCategoryChange}
                                onClose={handleReturnCategoryClose}
                                placeholder="Categories" />

                        </Stack>                        
                        <Stack spacing={10} direction="column" alignItems="flex-start">
                        <CheckTreePicker className="spacing" style={{ width: '25rem', marginRight: '1rem' }}
                                searchable={false}
                                defaultExpandAll
                                data={returnSaleMethodData}
                                onChange={handleReturnSaleMethodChange}
                                onClose={handleReturnSaleMethodClose}
                                placeholder="Sale Method" />
                        </Stack>
                    

                        {/*<div style={{ display: 'flex' }}>*/}
                        <Stack spacing={10} direction="column" alignItems="flex-start">
                        <CheckTreePicker className="spacing" style={{ width: '25rem' }}
                                searchable={false}
                                defaultExpandAll
                                data={returnStatusData}
                                value={SelectedReturnStatus}
                                cascade={false}  
                                onChange={handleReturnStatusData}
                                onClose={handleReturnStatusDataClose}
                                placeholder="Return Status" />
                        </Stack>
                        {/*</div>*/}
                    </div>
                    

                 {/*</div>*/}
                <div>
                    {tableLoadStatus ? (
                        <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
                            <CircularProgress sx={{ color: '#331b8c' }} />
                        </Box>
                    ) :
                            
                    <DataTable
                        columns={columns}
                        data={filteredData}
                        dense
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        pagination
                        highlightOnHover
                        responsive
                        paginationPerPage={50}
                        paginationRowsPerPageOptions={[50, 100, 150]}
                        customStyles={tableCustomStyles}
                    />
                         
                    }
                </div>                    
                
            
            
            
            {/*<div class="row">*/}
            {/*        <div class="col-sm-4">*/}
            {/*            <br />*/}
            {/*            <Button style={{ backgroundColor: "#f8f9fa", color: "#000" }} onClick={searchReturn}>*/}
            {/*                Search Return*/}
            {/*            </Button>*/}
            {/*        </div>*/}
            {/*</div>*/}
            <br />
            
            
                
        </>
                )


    }
    const tableCustomStyles = {
        table: {
            style: {
                backgroundColor: theme === 'light' ? '#ffffff' : '#000000', 
                color: '#ffffff',
                borderRadius: '8px'
            },
        },
        headCells: {
        style: {
            color: '#ffffff',
                backgroundColor: '#331b8c',
                fontSize:'0.875rem',
                height: '3rem',
            }
        },
        rows: {
            style: {
                backgroundColor: theme === 'light' ? '#ffffff' : '#000000',
                color: theme === 'light' ? '#000000' : '#ffffff',
                transition: 'background-color 0.3s',
            },                      
        },        
        pagination: {
            style: {
                backgroundColor: '#331b8c', // Footer background color
                color: 'white', // Footer text color
                padding: '10px', // Padding for footer
                borderTop: '2px solid #000', // Border at the top of the footer
                display: 'flex',
                justifyContent: 'center', // Center the pagination
                alignItems: 'center', // Center content vertically in footer
            },
            pageButtonsStyle: {
                // Default state: apply the color to the pagination arrows in normal state
                '& svg': {
                    fill: '#ffffff !important',
                    color: '#ffffff !important',
                },
                '&:hover:not(:disabled)': { // Hover style - change color when button is hovered
                    fill: '#ffffff !important',
                    color: '#ffffff !important'
                },
                '&:focus': { // Focus state: Change color when the button is focused
                    outline: 'none',
                    fill: '#ffffff !important',
                    color: '#ffffff !important'
                },
                // Disabled state: Set color when the pagination arrow is disabled
                '&:disabled': {
                    fill: '#d3d3d3 !important',
                    color: '#d3d3d3 !important',
                }
            },
        },
    }
    return (
        <>
            {data === true && handleDeleteSaleAlert()}
            <Modal size="lg" show={showModal} onHide={handleCloseModal} animation={false} className="dark-mode-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Sale</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure, you want to mark this sale as delete?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Cancel
                    </Button>
                    <Button style={{ backgroundColor: "#331b8c" }} onClick={Submit}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
                {showResidentialEdit && showChild ? <EditResidentialReturn {...{ saleId, setSaleId }} onGoBack={handleGoBack} /> :
                <>
                {showRuralEdit && showChild ? <EditRuralReturn {...{ saleId, setSaleId }} onGoBack={handleGoBack} /> :
                    filtersanddatatable()
                }
                </>
                }
        </>
    );
};

